export const FETCH_GAMES = 'FETCH_GAMES'
export const GET_DETAILS = 'GET_DETAILS'
export const LOADING_DETAILS = 'LOADING_DETAILS'
export const FETCH_SEARCHED_GAME = 'FETCH_SEARCHED_GAME'
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS'
